import * as OM from '@/model';
import * as CONST from '@/const';
import { RouteRecordRaw } from 'vue-router';

export class UploadFileVm
{
    entityIdentifier: string;
    file: File;
}

export class ExcelPreviewRequestVm {
    file: File;
}

export class ExcelColumnPreviewVm
{
    columnNumber: number;
    header: string;
    sampleValues: string[];
}

export class QrConfigExcelImportResultMessageVm
{
    messageType: string;
    text: string;
}

export class QrConfigExcelImportResultVm
{
    qrConfig: OM.QrConfig;
    row: number;
    messages: QrConfigExcelImportResultMessageVm[];
}

export class PrintQrCodesVm
{
    qrIdentifiers: string[];
    useSpecificTemplate: boolean;
    templateIdentifier: string;
    isSinglePdf: boolean;
}

export class DownloadedQrFileVm
{
    qrConfigIdentifier: string;
    qrConfigName: string;
    commessaName: string;
    url: string;
    fileName: string;
    localPath: string;
    downloadedOn: Date;
}

export class AddCommentVm
{
    fileList: File[];
    text: string;

    constructor(){
        this.fileList = [];
        this.text = "";
    }
}